module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }